var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVoice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    width: "800px",
    height: "800px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "microphone") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.788 14.371l-6.907 8.976c0.101 0.426 0.209 0.781 0.333 1.083-2.059 0.809-3.52 3.937-2.168 5.715 1.078 0.745 1.645 0.306 2.187 0.046-0.413-1.264-1.068-2.727 1.748-4.064 0.238 0.099 0.501 0.193 0.797 0.292l9.552-7.866-0.469 0.365c-2.91-0.133-4.674-1.851-5.073-4.546zM19.684 3.406c-0.942 1.066-1.518 2.463-1.532 3.994l-0-0-4.923 6.398c0.337 2.815 2.117 4.617 5.101 4.754l6.047-4.979c1.774-0.031 3.364-0.817 4.462-2.051l-0.064 0.062c-4.857-0.129-8.377-2.101-9.091-8.177zM17.514 15.302l-0.908-0.822 1.962-2.167 0.908 0.822-1.962 2.167zM24.267 1.339c-1.593 0-3.043 0.609-4.131 1.607 0.704 6.060 4.192 8.047 9.015 8.196 0.775-1.025 1.234-2.301 1.234-3.685 0-0.001 0-0.002 0-0.002-0.001-3.378-2.74-6.116-6.118-6.115z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVoice);
export default __webpack_public_path__ + "static/media/voice.720d58315799d4022bbce397929191a0.svg";
export { ForwardRef as ReactComponent };